import { connect } from "react-redux";
import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";

import LoadingComponent from "./lazy";

export default connect(null, { editTask, post })(LoadingComponent);
